module.exports = __webpack_public_path__ + "media/stylesheets/images/main/introduce_ceo_sm-e3a470e1c14f329c93b708a38d70fd1d.png";